import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  FlatList,
  StyleSheet,
  Keyboard,
} from "react-native";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
};

 

const ReceiverAddressStep: React.FC = ({ onValidationChange }: Props) => {
  const { t } = useTranslation();
  // display the field label from the gffpFieldsByCategory (from gffp response)
  const gffpFieldsByCategory = useSessionStore((s: SessionState) => (s as any).gffpFieldsByCategory);
  const receiverInfoFields: any[] = (gffpFieldsByCategory?.["Receiver Information"]) || [];
  const getFieldLabel = (tag: string): string | undefined => {
    const field = receiverInfoFields.find((f: any) => (f.XmlTag ?? f.xmlTag) === tag);
    return field?.FieldLabel ?? field?.fieldLabel;
  };

  const addressPlaceholder = getFieldLabel("senderAddress") || "Address";
  const cityPlaceholder = getFieldLabel("senderCity") || t("SENDER_ADDRESS_CITY_PLACEHOLDER");
  const postalPlaceholder = getFieldLabel("senderZipCode") || t("SENDER_ADDRESS_POSTAL_PLACEHOLDER");
  const statePlaceholder = getFieldLabel("senderState") || t("SENDER_ADDRESS_STATE_PLACEHOLDER");
  const [query, setQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const receiverAddress = useSessionStore((s: SessionState) => (s as any).receiverAddress) || "";
  const receiverCity = useSessionStore((s: SessionState) => (s as any).receiverCity) || "";
  const receiverZipCode = useSessionStore((s: SessionState) => (s as any).receiverZipCode) || "";
  const receiverState = useSessionStore((s: SessionState) => (s as any).receiverState) || "";
  const setReceiverAddress = useSessionStore((s: SessionState) => (s as any).setReceiverAddress);
  const setReceiverCity = useSessionStore((s: SessionState) => (s as any).setReceiverCity);
  const setReceiverZipCode = useSessionStore((s: SessionState) => (s as any).setReceiverZipCode);
  const setReceiverState = useSessionStore((s: SessionState) => (s as any).setReceiverState);

  const isValid = receiverAddress.trim().length > 0 &&
    receiverCity.trim().length > 0 &&
    receiverZipCode.trim().length > 0 &&
    receiverState.trim().length > 0 && receiverState.trim().length <= 2;
  
    useEffect(() => {
      if (onValidationChange) {
        onValidationChange(isValid);
      }
    }, [isValid, onValidationChange]);
  

  const handleSearch = (text: string) => {
    setQuery(text);
    if (text.length > 1) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };


  const handleFieildChange = (text: string) => {
    let isContinue = false;
    if (receiverAddress?.length > 1 &&
      receiverCity?.length > 1 &&
      receiverZipCode?.length > 1 &&
      receiverState?.length > 1) {
      isContinue = true
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t("SENDER_ADDRESS_TITLE")}</Text>
      <Text style={styles.subtitle}>{t("SENDER_ADDRESS_SUBTITLE")}</Text>

      {/* Search Field 
      <TextInput
        style={styles.input}
        placeholder="Search"
        value={query}
        onChangeText={handleSearch}
      />*/}

      {/* Suggestions List 
      {showSuggestions && (
        <FlatList
          data={suggestions}
          keyExtractor={(_, idx) => idx.toString()}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={styles.suggestionItem}
              onPress={() => handleSelectSuggestion(item)}
            >
              <Text style={styles.suggestionText}>
                {item.address}, {item.city}, {item.state}
              </Text>
            </TouchableOpacity>
          )}
        />
      )}*/}

      {/* Manual Entry Fields */}
        
        <View style={styles.form}>
          <TextInput
            style={styles.input}
            placeholder={addressPlaceholder}
            value={receiverAddress}
            onChangeText={(val) => { try { setReceiverAddress?.(val); } catch {} }}
          />
          
          <TextInput
            style={styles.input}
            placeholder={cityPlaceholder}
            value={receiverCity}
            onChangeText={(val) => { try { setReceiverCity?.(val); } catch {} }}
          />
          <TextInput
            style={styles.input}
            placeholder={postalPlaceholder}
            value={receiverZipCode}
            onChangeText={(val) => { try { setReceiverZipCode?.(val); } catch {} }}
          />
          <TextInput
            style={styles.input}
            placeholder={statePlaceholder}
            value={receiverState}
            onChangeText={(val) => { try { setReceiverState?.(val); } catch {} }}
          />
        </View>
      

      {/* Info Box */}
      <View style={styles.infoBox}>
        <Text style={styles.infoText}>
          {t("YOUR_INFO_IS_ALWAYS_KEPT_PRIVATE")}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { padding: 20, backgroundColor: "#FFF" },
  title: { fontSize: 22, fontWeight: "700", marginBottom: 4 },
  subtitle: { fontSize: 16, color: "#555", marginBottom: 16 },
  input: {
    backgroundColor: "#f5f5f5",
    padding: 12,
    borderRadius: 8,
    fontSize: 16,
    marginBottom: 10,
  },
  suggestionItem: { padding: 12, borderBottomWidth: 1, borderColor: "#eee" },
  suggestionText: { fontSize: 16 },
  form: { marginTop: 20 },
  manualBtn: { marginTop: 16, alignItems: "center" },
  manualText: { fontSize: 16, fontWeight: "600" },
  infoBox: {
    marginTop: 20,
    padding: 12,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
  },
  infoText: { fontSize: 14, color: "#333" },
});

export default ReceiverAddressStep;